import { toDollarAmount } from '@fastre/core/helperFunctions/number'
import { MarketingItemSchema, MarketingPackageSchema } from '@fastre/core/schemas/marketingPackage'
import { UpdateSaleListingSchema } from '@fastre/core/schemas/saleListing'
import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Modal,
    ModalClose,
    ModalDialog,
    Stack,
    Typography,
} from '@mui/joy'
import { useMarketingItemsApi } from 'apiProviders'
import ButtonSheet from 'components/buttonSheet'
import { dontCloseOnBackgroundClick } from 'components/modal'
import { filter, map, pipe } from 'ramda'
import { UseFormSetValue } from 'react-hook-form'
import { useListingContext } from './listingProvider'

interface MarketingPackageModalProps {
    open: boolean
    close: () => void
    setValue: UseFormSetValue<UpdateSaleListingSchema>
    currentPackage?: MarketingPackageSchema
}
const MarketingItemsModal = ({ open, close, currentPackage, setValue }: MarketingPackageModalProps) => {
    const { listing } = useListingContext()
    const marketingItemsApi = useMarketingItemsApi()

    return (
        <Modal
            open={open}
            onClose={dontCloseOnBackgroundClick(close)}
        >
            <ModalDialog
                sx={{
                    width: '100%',
                    minHeight: '600px',
                    maxWidth: '1000px',
                }}
            >
                <ModalClose />
                <DialogTitle>Marketing Package Items</DialogTitle>
                <DialogContent>
                    <Stack
                        direction="column"
                        gap={2}
                    >
                        {marketingItemsApi.maybeData.map(
                            pipe(
                                filter(
                                    (item: MarketingItemSchema) =>
                                        item.userIds == undefined ||
                                        item.userIds.length == 0 ||
                                        item.userIds.includes(listing.agents[0]?.userId),
                                ),
                                filter(
                                    (item: MarketingItemSchema) =>
                                        !currentPackage?.packageItems.some(pi => pi.itemId == item.itemId),
                                ),
                                map(item => (
                                    <ButtonSheet
                                        key={item.itemId}
                                        selected={currentPackage?.packageItems.some(
                                            i => i.itemId == item.itemId,
                                        )}
                                        onClick={() => {
                                            if (
                                                currentPackage?.packageItems.some(
                                                    i => i.itemId == item.itemId,
                                                )
                                            ) {
                                                return
                                            }

                                            setValue(
                                                'marketingPackage',
                                                {
                                                    packageName: currentPackage!.packageName,
                                                    packageItems: [...currentPackage!.packageItems, item],
                                                },
                                                { shouldDirty: true },
                                            )
                                            close()
                                        }}
                                    >
                                        <Typography>
                                            {item.itemName} - {toDollarAmount(item.itemPrice)}
                                        </Typography>
                                    </ButtonSheet>
                                )),
                            ),
                        )}
                        <Button
                            variant="outlined"
                            onClick={() => {
                                setValue(
                                    'marketingPackage',
                                    {
                                        packageName: currentPackage!.packageName,
                                        packageItems: [
                                            ...currentPackage!.packageItems,
                                            {
                                                itemCategory: 'Other',
                                                itemName: '',
                                                itemPrice: 0,
                                                userIds: [],
                                            },
                                        ],
                                    },
                                    { shouldDirty: true },
                                )
                                close()
                            }}
                        >
                            Custom
                        </Button>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Box>
                        <Button
                            variant="outlined"
                            onClick={close}
                        >
                            Cancel
                        </Button>
                    </Box>
                </DialogActions>
            </ModalDialog>
        </Modal>
    )
}

export default MarketingItemsModal
